import { render, staticRenderFns } from "./CampaignAddon.vue?vue&type=template&id=5b181006"
import script from "./CampaignAddon.vue?vue&type=script&lang=js"
export * from "./CampaignAddon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports